module.exports = __webpack_public_path__ + "01_face.a18e8de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/01_face.png
// module id = 5DTj
// module chunks = 0